// base of the project

// change to /mysubdirectory
// in order to compile the project if it needs to live
// in /mysubdirectory
export default '/'
